import { FC, useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import { useDispatch } from "react-redux";

import {
  startOfMonth,
  startOfWeek,
  endOfMonth,
  endOfWeek,
  subMonths,
  subWeeks,
  addDays,
} from "date-fns";
import ru from "date-fns/locale/ru";
import moment from "moment";

import { AppDispatch } from "../../../redux/reducer/store";
import { stateDate } from "../../../utils/formatDate";

import ButtonContainer from "./buttons";

import "react-date-range/dist/theme/default.css";
import "react-date-range/dist/styles.css";
import "./rangeDatePicker.scss";

interface IRangeDatePickerProps {
  handleClickClearBtn: () => void;
  defaultDateFrom?: string;
  setIsOpenDateBlock: (el: boolean) => void;
  setDateRange: (from: Date, to: Date) => void;
  handleClickAcceptBtn: any;
  setDateInputValues: any;
  setInputValues?: any;
  setCurrentPage?: any;
  defaultDateTo?: string;
  setStartPage?: any;
  inputValues?: any;
  reducer?: any;
  action?: any;
  limit?: number;
  page?: number;
  setLoading?: any;
  placeholder?: string;
  pageName?: string;
  name?: string;
  id?: number | string;
  position: string;
  date: string[] | Date[];
  isHiddenMenu: boolean;
  setIsHiddenMenu: (data: boolean) => void;
}

const OptionsComponent: FC<IRangeDatePickerProps> = ({
  handleClickAcceptBtn,
  handleClickClearBtn,
  setIsOpenDateBlock,
  setIsHiddenMenu,
  setCurrentPage,
  isHiddenMenu,
  setStartPage,
  setDateRange,
  inputValues,
  setLoading,
  pageName,
  reducer,
  action,
  limit,
  page,
  name,
  date,
  id,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [isClickOnAcceptBtn, setIsClickOnAcceptBtn] = useState<boolean>(false);
  const [isClickOnClearBtn, setIsClickOnClearBtn] = useState<boolean>(false);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const actualLimit = JSON.parse(localStorage.getItem("pageLimit") as string);

  const options = [
    { value: "Выбрать период", option: () => { setIsOpenDateBlock(true); } },
    { value: "Сегодня", option: () => setDateRange(new Date(), new Date()) },
    {
      value: "Вчера",
      option: () =>
        setDateRange(addDays(new Date(), -1), addDays(new Date(), -1)),
    },
    {
      value: "Прошлая неделя",
      option: () =>
        setDateRange(
          startOfWeek(subWeeks(new Date(), 1), {
            weekStartsOn: 1,
          }),
          endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 })
        ),
    },
    {
      value: "Последние 7 дней",
      option: () => setDateRange(addDays(new Date(), -6), new Date()),
    },
    {
      value: "Последние 30 дней",
      option: () => setDateRange(addDays(new Date(), -29), new Date()),
    },
    {
      value: "Этот месяц",
      option: () => {
        if (pageName === 'charts') {
          setDateRange(startOfMonth(new Date()), new Date());
        } else {
          setDateRange(startOfMonth(new Date()), endOfMonth(new Date()));
        }
      }
    },
    {
      value: "Предыдущий месяц",
      option: () =>
        setDateRange(
          startOfMonth(subMonths(new Date(), 1)),
          endOfMonth(subMonths(new Date(), 1))
        ),
    },
  ];

  useEffect(() => {
    registerLocale("ru", ru);
  }, []);

  useEffect(() => {
    if (isClickOnAcceptBtn) {
      const formattedDateFrom = moment(date && date[0]).format(
        "YYYY-MM-DD"
      );
      const formattedDateTo = moment(date[1] ? date[1] : date[0]).format(
        "YYYY-MM-DD"
      );

      handleDateUpdate(formattedDateFrom, formattedDateTo);
      setIsClickOnAcceptBtn(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClickOnAcceptBtn]);

  useEffect(() => {
    if (isClickOnClearBtn) {
      const fromDate = stateDate(startOfMonth(subMonths(new Date(), 1)));
      const toDate = stateDate(new Date());
      setDateRange(startOfMonth(subMonths(new Date(), 1)), new Date());
      handleDateUpdate(fromDate, toDate);
      setIsClickOnClearBtn(false);
      setCurrentPage(1);
      setStartPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClickOnClearBtn]);

  const handleDateUpdate = (fromDate: string, endDate: string) => {
    const toDate = new Date(endDate) > new Date() ? stateDate(new Date()) : endDate;

    const newInputValues = (pageName === 'applicationList')
      ? {
        ...inputValues,
        modifiedDate: {
          "from": fromDate,
          "to": toDate
        }
      }
      : pageName === 'vacancyList' ?
        {
          ...inputValues,
          [name as string]: {
            "from": fromDate,
            "to": toDate
          }
        }
        : {
          ...inputValues,
          fromDate,
          toDate,
        };
    if (id || id === 0) {
      if (pageName === 'charts') {
        dispatch(reducer({ id, value: { fromDate, toDate } }));
        setLoading(true);
      } else {
        dispatch(reducer({ id, data: newInputValues }));
        setLoading(true);
        dispatch(action(id)).then(() => {
          setLoading(false);
        })
      }
    } else {
      dispatch(reducer(newInputValues));
      setLoading(true);
      dispatch(action(actualLimit ? actualLimit : limit, page)).then(() => {
        setLoading(false);
      })
    }
  };

  const handleOptionClick = (option: string) => {
    const isSelected = selectedOptions?.some(
      (selectedOption) => selectedOption === option
    );

    if (isSelected) {
      setSelectedOptions([]);
      setDateRange(startOfMonth(subMonths(new Date(), 1)), new Date());

      if (option === "Выбрать период") {
        setIsOpenDateBlock(false);
      }
    } else {
      setSelectedOptions([option]);

      const selectedOption = options.find((item: { value: string, option: () => void }) => item.value === option);
      if (selectedOption) {
        selectedOption.option();
      }
    }
  };

  return (
    <>
      {isHiddenMenu ?
        <button
          onClick={() => { setIsOpenDateBlock(false); setSelectedOptions([]); }}
          className="modal__menu"
        />
        :
        <div className="filter__elem__block">
          {options.map((option: { value: string, option: () => void }) => (
            <div
              key={option.value}
              className={`elem ${selectedOptions?.some(
                (selectedOption) => selectedOption === option.value
              )
                ? "active__elem"
                : ""
                }`}
              onClick={() => handleOptionClick(option.value)}
            >
              {option.value}
            </div>
          ))}
          <ButtonContainer
            visible={true}
            handleClickAcceptBtn={handleClickAcceptBtn}
            handleClickClearBtn={handleClickClearBtn}
          />
        </div>}
    </>
  );
};

export default OptionsComponent;

